import { icons } from "./images";

const sideBarData = [
  {
    label: "Dashboard",
    to: "/dashboard",
    image: icons.fbIcon,
  },
];

const mediaLogo = (media) => {
  switch (media) {
    case "FACEBOOK":
      return icons.Facebook;
    case "INSTAGRAM":
      return icons.Insta;
    case "YOUTUBE":
      return icons.YouTube;
    case "TWITTER":
      return icons.Twitter;
    case "QUORA":
      return icons.Quora;
    default:
      return null;
  }
};

const purchaseStatus = {
  ALREADY_PURCHASED: "ALREADY_PURCHASED",
  NOT_PURCHASED: "NOT_PURCHASED",
  UPGRADABLE: "UPGRADABLE",
  ALREADY_PURCHASED_BETTER_PLAN: "ALREADY_PURCHASED_BETTER_PLAN",
  INACTIVE: "INACTIVE",
};

const planStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  FREE: "FREE",
};

const announcementHeader = ["Counselling", "News", "Details", "Links"];

const eventsHeader = ["Counselling", "Event Description", "Date"];

const repoMapping = {
  allotments: "Allotments",
  closingranks: "Closing Ranks",
  seatmatrix: "Seat Matrix",
  feestipendbond: "Fee, Stipend and Bond",
  choiceTable: "My Choice List",
  allotmentmapping: "Allotment Mapping",
  rankscan: "Rank Scan",
};

const supportContact = {
  PHONE_NUMBER_DISPLAY: "080-690-36000",
  PHONE_NUMBER_LINK: "tel:+918069036000",
  EMAIL: "hello@zynerd.com",
  EMAIL_LINK: "mailto:hello@zynerd.com",
};

const candidate_flag_colors = {
  violet: "#D3CDF2",
  blue: "#B3DAF9",
  green: "#D4F1C1",
  yellow: "#FFF4CE",
  pink: "#FFC0C0",
  purple: "#EDB3ED",
  brown: "#EEC2B5",
  turquoise: "#B5EFEF",
  orange: "#FFEEE5",
  gray: "#F0F0F0",
};

const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export {
  eventsHeader,
  announcementHeader,
  planStatus,
  purchaseStatus,
  mediaLogo,
  sideBarData,
  repoMapping,
  supportContact,
  candidate_flag_colors,
  months,
  days,
};
